/*!

 =========================================================
 * Global jss
 =========================================================
 */

// ##############################
// // // Variables - Styles that are used on more than one component
// #############################

// ##############################
// // // Function that converts from hex color to rgb color
// // // Example: input = #9c27b0 => output = 156, 39, 176
// // // Example: input = 9c27b0 => output = 156, 39, 176
// // // Example: input = #999 => output = 153, 153, 153
// // // Example: input = 999 => output = 153, 153, 153
// #############################
const hexToRgb = (input) => {
    input += '';
    input = input.replace('#', '');
    const hexRegex = /[0-9A-Fa-f]/g;
    if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
        throw new Error('input is not a valid hex color.');
    }
    if (input.length === 3) {
        const first = input[0];
        const second = input[1];
        const last = input[2];
        input = first + first + second + second + last + last;
    }
    input = input.toUpperCase(input);
    const first = input[0] + input[1];
    const second = input[2] + input[3];
    const last = input[4] + input[5];
    return (
        `${parseInt(first, 16)
        }, ${
            parseInt(second, 16)
        }, ${
            parseInt(last, 16)}`
    );
};

const hexToRgbBlur = (input, blur) => {
    input += '';
    input = input.replace('#', '');
    const hexRegex = /[0-9A-Fa-f]/g;
    if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
        throw new Error('input is not a valid hex color.');
    }
    if (input.length === 3) {
        const first = input[0];
        const second = input[1];
        const last = input[2];
        input = first + first + second + second + last + last;
    }
    input = input.toUpperCase(input);
    const first = input[0] + input[1];
    const second = input[2] + input[3];
    const last = input[4] + input[5];
    return (
        `${parseInt(first, 16)
        }, ${
            parseInt(second, 16)
        }, ${
            parseInt(last, 16)
        }, ${
            blur || 1
        }`
    );
};

const drawerWidth = 260;

const transition = {
    transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)',
};

const containerFluid = {
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%',
};

const boxShadow = {
    boxShadow:
    '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
};

const grayBoxShadow = {
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
};

const card = {
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    margin: '25px 0',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
    borderRadius: '3px',
    color: 'rgba(0, 0, 0, 0.87)',
    background: '#fff',
};

const defaultFont = {
    fontFamily: '"メイリオ", "Meiryo", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "Osaka", "MS PGothic", "ＭＳ Ｐゴシック", sans-serif',
    fontWeight: '300',
    lineHeight: '1.42857143',
    fontSize: '14px',
};

const primaryColor = '#1976d2';
const primaryLightColor = '#4791db';
const primaryDarkColor = '#115293';
const warningColor = '#ff9800';
const warningLightColor = '#ffb74d';
const warningDarkColor = '#f57c00';
const dangerColor = '#f44336';
const dangerLightColor = '#e57373';
const dangerDarkColor = '#d32f2f';
const successColor = '#4caf50';
const successLightColor = '#81c784';
const successDarkColor = '#388e3c';
const infoColor = '#2FC8FE';
const infoLightColor = '#00F2FE';
const infoDarkColor = '#4FACFE';
const roseColor = '#e91e63';
const roseLightColor = '#e33371';
const roseDarkColor = '#9a0036';
const grayColor = '#929292';
const whiteColor = '#ffffff';
const visitorLinkColor = '#202020';
const blackColor = '#000000';
const visitorColor = '#b2d1f9';
const exhibitorColor = '#8c0505';
const disabledColor = 'rgba(0, 0, 0, 0.12)'; // From Material-UI
const navyColor = '#001d83';
const navyDarkColor = '#001666';
const navyLightColor = '#0037ff';
const eventNameColor = '#2089ae';
const headerTableOrder = '#d8d8d8';
const lavenderTableOrder = '#d8e2f3';
const blackLightColor = '#949497';
const grayLightColor = '#bababd';

const primaryBoxShadow = {
    boxShadow:
    '0 12px 20px -10px rgb(71, 145, 219, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgb(17, 82, 147, 0.2)',
};
const infoBoxShadow = {
    boxShadow:
    '0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)',
};
const successBoxShadow = {
    boxShadow:
    '0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2)',
};
const warningBoxShadow = {
    boxShadow:
    '0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)',
};
const dangerBoxShadow = {
    boxShadow:
    '0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)',
};
const roseBoxShadow = {
    boxShadow:
    '0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)',
};

const warningCardHeader = {
    color: '#fff',
    background: 'linear-gradient(60deg, #ffa726, #fb8c00)',
    ...warningBoxShadow,
};
const successCardHeader = {
    color: '#fff',
    background: 'linear-gradient(60deg, #66bb6a, #43a047)',
    ...successBoxShadow,
};
const dangerCardHeader = {
    color: '#fff',
    background: 'linear-gradient(60deg, #ef5350, #e53935)',
    ...dangerBoxShadow,
};
const infoCardHeader = {
    color: '#fff',
    background: 'linear-gradient(60deg, #26c6da, #00acc1)',
    ...infoBoxShadow,
};
const primaryCardHeader = {
    color: '#fff',
    background: 'linear-gradient(60deg, #4791db, #115293)',
    ...primaryBoxShadow,
};
const roseCardHeader = {
    color: '#fff',
    background: 'linear-gradient(60deg, #ec407a, #d81b60)',
    ...roseBoxShadow,
};
const cardActions = {
    margin: '0 20px 10px',
    paddingTop: '10px',
    borderTop: '1px solid #eeeeee',
    height: 'auto',
    ...defaultFont,
};

const cardHeader = {
    margin: '-30px 15px 0',
    borderRadius: '3px',
    padding: '15px',
};

const defaultBoxShadow = {
    border: '0',
    borderRadius: '3px',
    boxShadow:
    '0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    padding: '10px 0',
    transition: 'all 150ms ease 0s',
};

export {
    // variables
    hexToRgb,
    drawerWidth,
    transition,
    containerFluid,
    boxShadow,
    card,
    defaultFont,
    primaryColor,
    primaryLightColor,
    primaryDarkColor,
    warningColor,
    warningLightColor,
    warningDarkColor,
    dangerColor,
    dangerLightColor,
    dangerDarkColor,
    successColor,
    successLightColor,
    successDarkColor,
    infoColor,
    infoLightColor,
    infoDarkColor,
    roseColor,
    roseLightColor,
    roseDarkColor,
    grayColor,
    primaryBoxShadow,
    infoBoxShadow,
    successBoxShadow,
    warningBoxShadow,
    dangerBoxShadow,
    roseBoxShadow,
    warningCardHeader,
    successCardHeader,
    dangerCardHeader,
    infoCardHeader,
    primaryCardHeader,
    roseCardHeader,
    cardActions,
    cardHeader,
    defaultBoxShadow,
    grayBoxShadow,
    whiteColor,
    blackColor,
    visitorColor,
    visitorLinkColor,
    exhibitorColor,
    disabledColor,
    navyColor,
    navyLightColor,
    navyDarkColor,
    eventNameColor,
    headerTableOrder,
    lavenderTableOrder,
    blackLightColor,
    grayLightColor,
    hexToRgbBlur,
};
